import "../styles/mailinglist.css";
import { useState } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";

function MailingList() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle");
    const [message, setMessage] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();

        const trimmedName = name.trim();
        const trimmedEmail = email.trim();

        if (!trimmedName) {
            setStatus("error");
            setMessage("Please enter your first name.");
            return;
        }

        if (!trimmedEmail) {
            setStatus("error");
            setMessage("Please enter your email address.");
            return;
        }

        setStatus("loading");
        setMessage("");

        try {
            const response = await fetch("/api/subscribe.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name: trimmedName,
                    email: trimmedEmail,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data.message || "Unable to add you to the mailing list."
                );
            }

            setStatus("success");
            setMessage("You're on the list! Watch your inbox for future updates.");
            setName("");
            setEmail("");
        } catch (error) {
            setStatus("error");
            setMessage(
                error.message || "Something went wrong. Please try again shortly."
            );
        }
    };

    return (
        <section className="mailing-list-section">
            <div className="container p-4">

                <div className="mailing-list-content">
                    <p className="mailing-list-eyebrow">Join the mailing list</p>

                    <h2>Get First Access</h2>

                    <p className="mailing-list-description">
                        Be the first to hear about new apparel and upcoming events.
                    </p>

                    <Form onSubmit={handleSubmit} noValidate>
                        <div className="mailing-list-inputs">
                            <Form.Control
                                type="text"
                                name="name"
                                value={name}
                                placeholder="First name"
                                aria-label="First name"
                                autoComplete="given-name"
                                onChange={(event) => setName(event.target.value)}
                                disabled={status === "loading"}
                                required
                            />

                            <Form.Control
                                type="email"
                                name="email"
                                value={email}
                                placeholder="Email address"
                                aria-label="Email address"
                                autoComplete="email"
                                onChange={(event) => setEmail(event.target.value)}
                                disabled={status === "loading"}
                                required
                            />
                        </div>

                        <Button
                            type="submit"
                            disabled={status === "loading"}
                            className="mailing-list-button"
                        >
                            {status === "loading" ? (
                                <>
                                    <Spinner
                                        animation="border"
                                        size="sm"
                                        className="me-2"
                                        aria-hidden="true"
                                    />
                                    Joining
                                </>
                            ) : (
                                "Get First Access"
                            )}
                        </Button>

                        <Form.Text className="mailing-list-note">
                            No spam. Just new releases and updates. Unsubscribe anytime.
                        </Form.Text>
                    </Form>

                    {message && (
                        <Alert
                            variant={status === "success" ? "success" : "danger"}
                            className="mailing-list-alert"
                        >
                            {message}
                        </Alert>
                    )}
                </div>
            </div>
        </section>
    );
}

export default MailingList;